export const PRODUCT_TAG_SEARCH = 'PRODUCT_TAG_SEARCH';
